import React from 'react';
import FeatureTab from './FeatureTab';
import TemporaryDashboardTabs from './TemporaryDashboardTabs';
import {
  TAB_TITLE_OVB,
  TAB_TITLE_TRENDS,
  TAB_TITLE_AI_ALERT,
  TAB_TITLE_NOC,
  TAB_TITLE_AI_ALERTS_COHORTS,
} from 'utils/constants';
import renderShared from '@components/common/Dashboard/SharedTabs';
import AccessWrapper from './AccessWrapper';
import SavedDashboardsTab from './SavedDashboardsTab';
import featureNames, { globalFeatureNames } from '@utils/featureToggle/constants';
import DashboardList from './DashboardList';
import { useSelector } from 'react-redux';
import { appExperienceShareAndSaveSelector } from '@store/common/selectors';
import UseCases from '../UseCases';
import { useGlobalFeature } from '@src/globalStore/globalFeatureFlagsStore';

const AppTabs = ({ shareId }) => {
  const renderSharedTab = renderShared(shareId);
  const appExperienceShareAndSaveFeature = useSelector(appExperienceShareAndSaveSelector);
  const enableDPICustomDimension = useGlobalFeature(globalFeatureNames.DPI_CUSTOM_DIMENSION);
  return (
    <>
      <UseCases />

      <FeatureTab
        tabKey="overview"
        isGA={false}
        feature={featureNames.DPI_OVERVIEW}
        tabTitle={TAB_TITLE_OVB}
        route="/dashboard/overview"
        exact
      />

      <FeatureTab
        tabKey="app-experience"
        isGA
        feature={null}
        tabTitle={TAB_TITLE_TRENDS}
        route="/dashboard/app-experience"
        exact
      />

      <FeatureTab
        tabKey="user-timeline"
        isGA
        feature={null}
        tabTitle="Users"
        route="/dashboard/user-timeline"
        exact
      />
      <FeatureTab
        tabKey="real-time"
        isGA
        feature={featureNames.NOC}
        tabTitle={<span>{TAB_TITLE_NOC}</span>}
        route="/dashboard/real-time"
        exact
      />

      <FeatureTab
        tabKey="ai-alerts"
        isGA={false}
        feature={featureNames.APP_AI_ALERTS}
        tabTitle={TAB_TITLE_AI_ALERT}
        route="/dashboard/ai-alerts"
        exact
      />

      {!enableDPICustomDimension ? (
        <FeatureTab
          tabKey="ai-alerts-cohorts"
          isGA={false}
          feature={featureNames.APP_AI_ALERTS}
          tabTitle={TAB_TITLE_AI_ALERTS_COHORTS}
          route="/dashboard/ai-cohorts"
          exact
        />
      ) : null}

      {appExperienceShareAndSaveFeature ? (
        <AccessWrapper feature={featureNames.SAVED_DASHBOARDS}>
          <SavedDashboardsTab />
        </AccessWrapper>
      ) : null}

      <TemporaryDashboardTabs renderSharedTab={renderSharedTab} activeId={`${shareId}`} />
      {appExperienceShareAndSaveFeature ? <DashboardList id={`${shareId}`} /> : null}
    </>
  );
};

export default AppTabs;
